// extracted by mini-css-extract-plugin
module.exports = {"empty-table":"empty-table_3qdm","img-wrap":"img-wrap_1R4R"};